module.exports = __webpack_public_path__ + "img/kFb.bb96ea98.png";